import "./marketplace.bfa450ec.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6aa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6aa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kVpyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bcf4641bf8382d$export$2e2bcd8739ae039);
// Light / dark mode toggle (the .theme-toggle buttons).
// The inline script in each page's <head> already set html[data-theme] before
// the first paint; this only handles the buttons and system changes.
// The visitor's choice is remembered; without one, the system setting wins.
const $f3bcf4641bf8382d$var$KEY = "theme";
function $f3bcf4641bf8382d$export$2e2bcd8739ae039() {
    const root = document.documentElement;
    const system = window.matchMedia("(prefers-color-scheme: dark)");
    const buttons = [
        ...document.querySelectorAll(".theme-toggle")
    ];
    function saved() {
        try {
            const t = localStorage.getItem($f3bcf4641bf8382d$var$KEY);
            return t === "dark" || t === "light" ? t : null;
        } catch  {
            return null;
        }
    }
    function apply(theme) {
        root.dataset.theme = theme;
        const next = theme === "dark" ? "light" : "dark";
        for (const b of buttons){
            b.setAttribute("aria-label", `Switch to ${next} mode`);
            b.title = `Switch to ${next} mode`;
            b.querySelector("i").className = `fa fa-${theme === "dark" ? "sun-o" : "moon-o"}`;
        }
    }
    for (const b of buttons)b.addEventListener("click", ()=>{
        const theme = root.dataset.theme === "dark" ? "light" : "dark";
        try {
            localStorage.setItem($f3bcf4641bf8382d$var$KEY, theme);
        } catch  {}
        apply(theme);
    });
    system.addEventListener("change", (e)=>{
        if (!saved()) apply(e.matches ? "dark" : "light");
    });
    apply(root.dataset.theme === "dark" ? "dark" : "light");
}

});

parcelRegister("wUWAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $062f29282c0d813b$export$2e2bcd8739ae039);
// "Ask about me" chat: a cartoon-character button that opens a chat panel (a card on
// desktop, a full-screen sheet on phones). Questions go to the resume-chat
// service (resume-chat/), which answers from resume.txt with the Ollama model on
// the server and streams the reply back as plain text.
//
// The character reacts to the conversation through classes on .chat:
//   is-open      panel shown        is-thinking  waiting for the first words
//   is-talking   answer streaming   is-sad       something went wrong
// In production Caddy forwards /api/chat to it; locally it runs on localhost:8082.
const $062f29282c0d813b$var$LOCAL = [
    "localhost",
    "127.0.0.1"
].includes(location.hostname);
const $062f29282c0d813b$var$CHAT_URL = ($062f29282c0d813b$var$LOCAL ? "http://localhost:8082" : "") + "/api/chat";
const $062f29282c0d813b$var$WARM_EVERY_MS = 60000; // the server ignores more frequent warm-ups anyway
const $062f29282c0d813b$var$WAKING_AFTER_MS = 6000; // no words yet: the model is probably loading
const $062f29282c0d813b$var$MAX_LEN = 1000; // same limit as the server
const $062f29282c0d813b$var$KEEP = 12; // turns sent with each question
const $062f29282c0d813b$var$TEASER_AFTER_MS = 4000;
const $062f29282c0d813b$var$TEASER_FOR_MS = 7000;
const $062f29282c0d813b$var$TEASER_KEY = "chat-teaser-seen";
const $062f29282c0d813b$var$GREETING = "Hi! I'm Kamado, Abdelilah's assistant. Ask me anything about his skills, projects or experience.";
// One-tap questions under the greeting, for recruiters short on time. The
// server answers the first two from his files at once; the last is a download.
const $062f29282c0d813b$var$QUICK = [
    {
        label: "Abdelilah in 30 seconds",
        ask: "Who is Abdelilah?"
    },
    {
        label: "Is he available?",
        ask: "Is he available?"
    },
    {
        label: "Why hire him?",
        ask: "Why should I hire him?"
    },
    {
        label: "Download his CV",
        href: "/assets/resume.pdf",
        download: "Abdelilah_Bouchikhi_Resume_EN.pdf"
    }
];
const $062f29282c0d813b$var$STATUS = {
    idle: "Online",
    thinking: "Thinking\u2026",
    waking: "Waking up, the first answer takes a moment\u2026",
    talking: "Typing\u2026",
    sad: "Hmm, something went wrong"
};
// Cartoon sidekick (original character): big touching eyes with tiny pupils,
// a bald shiny head, a nervous wavy mouth. Its parts are animated from _chat.scss.
function $062f29282c0d813b$var$robot(extraClass = "") {
    return `
    <svg class="bot ${extraClass}" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <g class="bot__head">
        <ellipse class="bot__ear" cx="13.5" cy="36.5" rx="3.6" ry="5" />
        <ellipse class="bot__ear" cx="50.5" cy="36.5" rx="3.6" ry="5" />
        <path class="bot__face" d="M15.5 30C14 18 22 11.5 32 11.5S50.5 18 48.8 31C49.6 44 43 54.5 32 54.5S14.5 44 15.5 30Z" />
        <path class="bot__shine" d="M21.8 19.6q4.3-3.3 10-3.6" />
        <path class="bot__brow" d="M18.6 24.6q5-2.4 10-.2" />
        <path class="bot__brow" d="M35.4 24.4q5-2.2 10 .2" />
        <g class="bot__eye">
          <circle class="bot__white" cx="24.4" cy="34" r="8" />
          <circle class="bot__white" cx="39.6" cy="34" r="8" />
        </g>
        <g class="bot__eyes">
          <circle class="bot__pupil" cx="26" cy="34.4" r="1.6" />
          <circle class="bot__pupil" cx="38" cy="34.4" r="1.6" />
        </g>
        <path class="bot__mouth" d="M25 48.4q1.75-1.9 3.5 0t3.5 0 3.5 0 3.5 0" />
        <path class="bot__drop" d="M52.5 14c1.7 2.6 2.6 4.2 2.6 5.4a2.6 2.6 0 0 1-5.2 0c0-1.2.9-2.8 2.6-5.4Z" />
      </g>
    </svg>`;
}
function $062f29282c0d813b$export$2e2bcd8739ae039() {
    const root = document.createElement("div");
    root.className = "chat";
    root.innerHTML = `
    <p class="chat__teaser" aria-hidden="true">Hi, I'm Kamado! Ask me about Abdelilah</p>
    <button type="button" class="chat__toggle" aria-expanded="false" aria-controls="chat-panel"
      aria-label="Chat with Kamado, Abdelilah's assistant">
      ${$062f29282c0d813b$var$robot("bot--launcher")}
      <span class="chat__toggle-close" aria-hidden="true"><i class="fa fa-times"></i></span>
    </button>
    <section class="chat__panel" id="chat-panel" role="dialog" aria-labelledby="chat-title" inert>
      <header class="chat__head">
        <span class="chat__grip" aria-hidden="true"></span>
        <div class="chat__avatar">${$062f29282c0d813b$var$robot()}</div>
        <div class="chat__title">
          <strong id="chat-title">Kamado</strong>
          <small class="chat__status">${$062f29282c0d813b$var$STATUS.idle}</small>
        </div>
        <button type="button" class="chat__close" aria-label="Close chat"><i class="fa fa-times"></i></button>
      </header>
      <div class="chat__log" aria-live="polite"></div>
      <form class="chat__form">
        <textarea rows="1" maxlength="${$062f29282c0d813b$var$MAX_LEN}" placeholder="Ask a question\u{2026}" aria-label="Your question"
          enterkeyhint="send" required></textarea>
        <button type="submit" aria-label="Send"><i class="fa fa-arrow-up"></i></button>
      </form>
      <p class="chat__note">Kamado is an AI assistant. It can make mistakes.</p>
    </section>`;
    document.body.appendChild(root);
    const toggle = root.querySelector(".chat__toggle");
    const teaser = root.querySelector(".chat__teaser");
    const panel = root.querySelector(".chat__panel");
    const head = root.querySelector(".chat__head");
    const status = root.querySelector(".chat__status");
    const log = root.querySelector(".chat__log");
    const form = root.querySelector(".chat__form");
    const input = form.querySelector("textarea");
    const send = form.querySelector("button");
    // Same breakpoint as the full-screen sheet in _chat.scss
    const phone = window.matchMedia("(max-width: 37.5em), (max-height: 31.25em)");
    const history = [];
    let busy = false;
    let greeted = false;
    // The deck changes slides on wheel and swipe: keep those inside the panel
    for (const type of [
        "wheel",
        "touchstart",
        "touchmove",
        "touchend"
    ])panel.addEventListener(type, (e)=>e.stopPropagation(), {
        passive: true
    });
    // ---- robot mood ----
    function mood(name) {
        root.classList.remove("is-thinking", "is-talking", "is-sad");
        if (name !== "idle") root.classList.add(`is-${name}`);
        status.textContent = $062f29282c0d813b$var$STATUS[name];
    }
    // ---- open / close ----
    function isOpen() {
        return root.classList.contains("is-open");
    }
    function setOpen(open) {
        if (open === isOpen()) return;
        root.classList.toggle("is-open", open);
        panel.inert = !open;
        toggle.setAttribute("aria-expanded", String(open));
        toggle.setAttribute("aria-label", open ? "Close the chat" : "Chat with Kamado, Abdelilah's assistant");
        hideTeaser();
        if (open) {
            warmUp();
            fitViewport();
            if (!greeted) {
                greeted = true;
                setTimeout(()=>{
                    bubble("bot", $062f29282c0d813b$var$GREETING);
                    quickButtons();
                }, 280);
            }
            // On phones the keyboard would cover the greeting: let them tap the field
            if (!phone.matches) setTimeout(()=>input.focus({
                    preventScroll: true
                }), 320);
        } else {
            input.blur();
            if (!phone.matches) toggle.focus({
                preventScroll: true
            });
        }
    }
    toggle.addEventListener("click", ()=>setOpen(!isOpen()));
    // Wake the model up as soon as the visitor shows interest: it loads and reads
    // its notes (up to a minute on the server's CPU) while they type
    let lastWarm = 0;
    function warmUp() {
        if (Date.now() - lastWarm < $062f29282c0d813b$var$WARM_EVERY_MS) return;
        lastWarm = Date.now();
        fetch($062f29282c0d813b$var$CHAT_URL + "/warm", {
            method: "POST",
            keepalive: true
        }).catch(()=>{});
    }
    for (const type of [
        "pointerenter",
        "focus",
        "touchstart"
    ])toggle.addEventListener(type, warmUp, {
        passive: true
    });
    root.querySelector(".chat__close").addEventListener("click", ()=>setOpen(false));
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && isOpen()) setOpen(false);
    });
    // Phones: drag the header down to close the sheet
    let dragY = null;
    let dragDy = 0;
    head.addEventListener("touchstart", (e)=>{
        if (!phone.matches || e.target.closest("button")) return;
        dragY = e.touches[0].clientY;
        dragDy = 0;
        panel.classList.add("is-dragging");
    }, {
        passive: true
    });
    head.addEventListener("touchmove", (e)=>{
        if (dragY === null) return;
        dragDy = Math.max(0, e.touches[0].clientY - dragY);
        panel.style.setProperty("--drag", `${dragDy}px`);
    }, {
        passive: true
    });
    function endDrag() {
        if (dragY === null) return;
        dragY = null;
        panel.classList.remove("is-dragging");
        panel.style.removeProperty("--drag");
        if (dragDy > 90) setOpen(false);
    }
    head.addEventListener("touchend", endDrag);
    head.addEventListener("touchcancel", endDrag);
    // Phones: keep the sheet inside the visible area when the keyboard opens
    function fitViewport() {
        const vv = window.visualViewport;
        if (!vv) return;
        root.style.setProperty("--chat-vh", `${vv.height}px`);
        root.style.setProperty("--chat-top", `${vv.offsetTop}px`);
        log.scrollTop = log.scrollHeight;
    }
    window.visualViewport?.addEventListener("resize", fitViewport);
    window.visualViewport?.addEventListener("scroll", fitViewport);
    // ---- teaser bubble next to the robot, once per visit ----
    let teaserSeen = false;
    try {
        teaserSeen = sessionStorage.getItem($062f29282c0d813b$var$TEASER_KEY) === "1";
    } catch  {}
    function hideTeaser() {
        teaser.classList.remove("is-shown");
    }
    if (!teaserSeen) setTimeout(()=>{
        if (isOpen()) return;
        teaser.classList.add("is-shown");
        try {
            sessionStorage.setItem($062f29282c0d813b$var$TEASER_KEY, "1");
        } catch  {}
        setTimeout(hideTeaser, $062f29282c0d813b$var$TEASER_FOR_MS);
    }, $062f29282c0d813b$var$TEASER_AFTER_MS);
    // ---- messages ----
    input.addEventListener("keydown", (e)=>{
        if (e.key === "Enter" && !e.shiftKey && !e.isComposing && !phone.matches) {
            e.preventDefault();
            form.requestSubmit();
        }
    });
    input.addEventListener("input", grow);
    form.addEventListener("submit", (e)=>{
        e.preventDefault();
        ask(input.value);
    });
    function grow() {
        input.style.height = "auto";
        input.style.height = Math.min(input.scrollHeight, 120) + "px";
    }
    function bubble(role, text) {
        const row = document.createElement("div");
        row.className = `chat__row chat__row--${role}`;
        if (role === "bot") row.innerHTML = `<span class="chat__mini">${$062f29282c0d813b$var$robot()}</span>`;
        const msg = document.createElement("p");
        msg.className = `chat__msg chat__msg--${role}`;
        msg.textContent = text;
        row.appendChild(msg);
        log.appendChild(row);
        log.scrollTo({
            top: log.scrollHeight,
            behavior: "smooth"
        });
        return msg;
    }
    let quick = null;
    function quickButtons() {
        quick = document.createElement("div");
        quick.className = "chat__quick";
        quick.setAttribute("role", "group");
        quick.setAttribute("aria-label", "Quick questions");
        for (const q of $062f29282c0d813b$var$QUICK){
            const el = document.createElement(q.href ? "a" : "button");
            el.className = "chat__chip";
            el.textContent = q.label;
            if (q.href) {
                el.href = q.href;
                el.download = q.download;
                el.prepend(Object.assign(document.createElement("i"), {
                    className: "fa fa-download"
                }));
            } else {
                el.type = "button";
                el.addEventListener("click", ()=>ask(q.ask));
            }
            quick.appendChild(el);
        }
        log.appendChild(quick);
    }
    function typing() {
        const msg = bubble("bot", "");
        msg.classList.add("chat__msg--typing");
        msg.innerHTML = '<span class="chat__dots" role="img" aria-label="Thinking"><i></i><i></i><i></i></span>';
        return msg;
    }
    async function ask(raw) {
        const question = raw.trim().slice(0, $062f29282c0d813b$var$MAX_LEN);
        if (!question || busy) return;
        busy = true;
        send.disabled = true;
        input.value = "";
        grow();
        // the buttons are a way to start: once the visitor asks, they go
        quick?.remove();
        quick = null;
        bubble("user", question);
        history.push({
            role: "user",
            content: question
        });
        const out = typing();
        mood("thinking");
        const waking = setTimeout(()=>{
            if (out.classList.contains("chat__msg--typing")) status.textContent = $062f29282c0d813b$var$STATUS.waking;
        }, $062f29282c0d813b$var$WAKING_AFTER_MS);
        let answer = "";
        try {
            const res = await fetch($062f29282c0d813b$var$CHAT_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    messages: history.slice(-$062f29282c0d813b$var$KEEP)
                })
            });
            if (!res.ok) {
                const data = await res.json().catch(()=>({}));
                throw new Error(data.error || "Something went wrong, please try again.");
            }
            const reader = res.body.getReader();
            const decoder = new TextDecoder();
            for(;;){
                const { value: value, done: done } = await reader.read();
                if (done) break;
                answer += decoder.decode(value, {
                    stream: true
                });
                if (!answer) continue;
                if (out.classList.contains("chat__msg--typing")) {
                    out.classList.remove("chat__msg--typing");
                    mood("talking");
                }
                out.textContent = answer;
                log.scrollTop = log.scrollHeight;
            }
            if (!answer.trim()) throw new Error("No answer this time, please try again.");
            history.push({
                role: "assistant",
                content: answer
            });
            mood("idle");
        } catch (err) {
            history.pop(); // forget the unanswered question
            out.classList.remove("chat__msg--typing");
            out.classList.add("chat__msg--error");
            out.textContent = err instanceof TypeError ? "Can't reach Kamado right now." : err.message;
            mood("sad");
            setTimeout(()=>!busy && mood("idle"), 4000);
        } finally{
            clearTimeout(waking);
            busy = false;
            send.disabled = false;
            if (!phone.matches) input.focus({
                preventScroll: true
            });
        }
    }
}

});


var $kVpyw = parcelRequire("kVpyw");

var $wUWAt = parcelRequire("wUWAt");

var $ijXQL = parcelRequire("ijXQL");
// Case-study pages (marketplace.html, blog-platform.html)
(0, $kVpyw.default)();
(0, $wUWAt.default)();
(0, $ijXQL.default)();


//# sourceMappingURL=marketplace.f25e4641.js.map
